export default __webpack_public_path__ + "assets/mememusic.MP3";